module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [(_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('dashboard');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/dashboard',
        query: _vm.$route.query
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.dashboard')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": [function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }, function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }]
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointment',
        query: {
          status: 'pending',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointment_pending')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPending) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(_vm._s(_vm.pendingSize))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointments',
        query: {
          status: 'scheduled',
          viewType: 'daily',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointments')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('calendar');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/appointments',
        query: {
          status: 'scheduled',
          viewType: 'daily',
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.appointments')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('leave');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/clinic/leave',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_leave')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('leave');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": '/doctor/leave'
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_leave')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/broadcast',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sms_broadcast')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/article',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.article')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('feedback');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/feedback',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.feedback')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor() || _vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('report');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/report',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.report')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('patient');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.$guser.isPremiumAccount()
    },
    attrs: {
      "to": {
        path: '/patient',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.patient')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item nav-dropdown active open",
    attrs: {
      "tag": "li",
      "to": {
        path: ''
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_info')))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/general',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_information')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/clinic_address',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_address')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/schedules',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_schedule')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/services',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_services')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.checkFeature('settings');
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'no-feature': !_vm.isActive()
    },
    attrs: {
      "to": {
        path: '/clinic/setting',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      },
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('message.menu.clinic_settings')) + " "), (!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/doctor/step1/me'
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctor')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/doctor/setting'
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_settings')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleMenuClick($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/clinic/doctors',
        query: {
          ref_clinic_id: _vm.$route.query.ref_clinic_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctors')) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic(_vm.$route)) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.handleMenuClick
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": _vm.clinicUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.clinic_view')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.$guser.isDoctor()) ? _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.handleMenuClick
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": _vm.doctorUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.doctor_view')) + " ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": _vm.signout
    }
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sign_out')))])])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive()) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "src": "/static/audio/notification.mp3",
      "preload": "auto",
      "id": "player"
    }
  }, [_c('p', [_vm._v("Your browser does not support the "), _c('code', [_vm._v("audio")]), _vm._v(" element.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e6d158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/containerComponents/Sidebar.vue
// module id = 1053
// module chunks = 1